export default __webpack_public_path__ + "static/media/igiv-logo-small.9a25e52c.png";